import React from 'react';
import './dotSpinStyles.css';
import CircularProgress from '@material-ui/core/CircularProgress';

const DotSpin = () =>
{
	return (
		<div className='loaderCntnr1 internalLoader'>
			<CircularProgress/>
		</div>
	);
};

export default DotSpin;
